import { EventEmitter } from 'events';
export default new EventEmitter();
//# sourceMappingURL=emitter.js.map